import React from 'react'
import { withUserStore } from '../../contexts/UserStore'
import { Input, Label } from '@byscott-io/corebyscott'
import PageView from './PageView'
import Lex from '../Shared/Lex'
// import {withPrioritiesApi} from "../../apis/priorities_api"
import CommentThread from './CommentThread/CommentThread'
import PageProvider from '../../modules/PageProvider'

const Priorities = ({userStore}) => {
  const form = {}

  const page = {
    clickUrl: (record) => 'priority/' + record.id + '/strategies',
    formName: () => userStore.lex.priority,
    recordType: () => 'priorities',
    pageHeader: () => <span><h3 className="inline-block"><Lex term="priority" plural /></h3></span>,
    newRecord: () => {
      return { name: '', description: '' }
    },
    records: () => {
      return userStore.getRecords('priorities', (a, b) =>
        ((a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : (b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0))
    },
    formFields: (record) => {
      //    if (record == null) record = { name: '', description: '' }
      record ||= { name: '', description: '' }
      return <div><Label><Lex term="name" /></Label><Input data-cy="priority-name-input" innerRef={el => form.name = el} defaultValue={record.name} />
        <br />
        <Label><Lex term="description" /></Label><Input
          data-cy="priority-description-input"
          innerRef={el => form.description = el}
          defaultValue={record.description}
        />
      </div>
    },
    saveRecord: (record) => {
      record.name = form.name.value
      record.description = form.description.value
      if (record.id) { userStore.updatePriority(record) } else { userStore.createPriority(record.name, record.description, userStore.account?.id) }
      return true
    },
    destroy: (record) => userStore.destroyPriority(record),
    showJournal: false,
    showComment: true,
    commentThreadPageProvider: {
      formFields: (record) => <CommentThread commentable={record}>{record.name}</CommentThread>,
      record: () => { return {} }
    }
  }

  return <PageView pageProvider={PageProvider(page)} />
}

export default withUserStore(Priorities)
